"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoryPublicationDate = void 0;
function getStoryPublicationDate(story) {
    const { published_at } = story;
    if (!published_at) {
        return null;
    }
    return typeof published_at === 'string'
        ? new Date(published_at)
        : new Date(published_at * 1000);
}
exports.getStoryPublicationDate = getStoryPublicationDate;
//# sourceMappingURL=getStoryPublicationDate.js.map